import { useSelector } from 'react-redux';
import { makeSelectQuery } from 'services/query/query.selectors';

function useQueryData<TData>(queryKey: string) {
  const queryData = useSelector(makeSelectQuery(queryKey));

  return {
    data: queryData.data as TData | undefined,
    timestamp: queryData.timestamp,
    status: queryData.status,
  };
}

export { useQueryData };
